<template>
  <div>
    <h1 class="page-title">
      My events
      <AddButton
        class="my-events-add-button glass-element"
        :handle-click="() => (displayEventForm = true)"
        v-if="!displayEventForm"
      />
    </h1>
    <transition name="fade">
      <EventForm
        :event="currentEvent"
        :handle-close="() => (displayEventForm = false)"
        v-if="displayEventForm"
      />
    </transition>
    <EventList v-if="myEvents" :events="myEvents" />
    <LoaderLight v-if="loading" />
  </div>
</template>

<script>
import AddButton from "@/components/atoms/AddButton";
import EventList from "@/components/molecules/EventList";
import EventForm from "@/components/molecules/EventForm";
import LoaderLight from "@/components/atoms/LoaderLight";
import { mapState } from "vuex";

export default {
  components: {
    EventList,
    EventForm,
    AddButton,
    LoaderLight,
  },
  data() {
    return {
      currentEvent: null,
      displayEventForm: false,
      loading: false,
    };
  },
  computed: mapState({
    myEvents: (state) => state.events?.myEvents?.results,
    userId: (state) => state.profiles.ownProfile.id,
  }),
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("getMyEvents", this.userId);
    this.loading = false;
  },
};
</script>
